module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-03.ba2c7c41.jpg";